import { EdgeLabel } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/EdgeLabel/EdgeLabel.tsx';
import { BaseEdge, EdgeProps, getSmoothStepPath } from '@xyflow/react';

/** Step edge whose label is HTML rather than SVG text, so it can hold more than a plain string. */
export const StepEdgeWithLabel = ({
	id,
	sourceX,
	sourceY,
	sourcePosition,
	targetX,
	targetY,
	targetPosition,
	style,
	label,
	labelStyle,
	markerStart,
	markerEnd,
	interactionWidth,
}: EdgeProps) => {
	const [path, labelX, labelY] = getSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
		borderRadius: 0,
	});

	return (
		<>
			<BaseEdge
				id={id}
				path={path}
				style={style}
				markerStart={markerStart}
				markerEnd={markerEnd}
				interactionWidth={interactionWidth}
			/>
			{label && (
				<EdgeLabel edgeId={id} x={labelX} y={labelY} labelStyle={labelStyle}>
					{label}
				</EdgeLabel>
			)}
		</>
	);
};
